export default __webpack_public_path__ + "static/panel-on-roof-077e2b7fb43632c0c58e2018610e17a2.jpg";